const getDefaultState = () => ({
  selectedDomainId: null,
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/ski/defaultState.js